import { forwardRef } from "react";

import type { ImageWrapperProps } from "./ImageBehaviourContext";
import { useImage } from "./ImageBehaviourContext";

export type ImageBehaviourProps = ImageWrapperProps & {
  nativeBehaviour?: boolean;
};

export const ImageBehaviour = forwardRef<HTMLImageElement, ImageBehaviourProps>(
  ({ nativeBehaviour, alt, ...props }, ref) => {
    const ImageComponent = useImage();
    if (!ImageComponent || nativeBehaviour) {
      return <img ref={ref} alt={alt} {...props} />;
    }
    return <ImageComponent alt={alt} {...props} />;
  }
);

ImageBehaviour.displayName = "ImageBehaviour";
